module.exports = __webpack_public_path__ + "img/stakebody_driving.687cd52c.svg";